<template>
    <div class="border-top">
        <SOFilterTitle title="Status Mesin EDC" :diterapkan="diterapkan" :id="id" />
        <div class="p-l-24 p-r-24 p-d-24" style="display: none" :id="id">
            <SOInputCheckbox :checked="filterItem.statusMesinEdc" :checkboxes="statusMesinEdc" @selected="selected" />
        </div>
    </div>
</template>

<script>
import SOFilterTitle from "@/so-components/global/filter/base/SOFilterTitle";
import SOInputCheckbox from "@/so-components/global/input/SOInputCheckbox";
import { mapGetters } from "vuex";

export default {
    name: "SOFilterStatusMesinEdc",
    components: { SOInputCheckbox, SOFilterTitle },
    props: {
        id: String,
    },
    data() {
        return {
            statusMesinEdc: {
                name: "status-mesin-edc",
                data: [
                    {
                        id: "status-mesin-edc-1",
                        value: "1",
                        title: "Aktif",
                        checked: false,
                        titleBold: false,
                    },
                    {
                        id: "status-mesin-edc-2",
                        value: "2",
                        title: "Nonaktif",
                        checked: false,
                        titleBold: false,
                    },
                ],
            },
            diterapkan: false,
        };
    },
    mounted() {
        this.diterapkan = this.filterItem.statusMesinEdc.length > 0;
    },
    computed: {
        ...mapGetters("filterGlobalModule", {
            filterItem: "getFilterItem",
        }),
    },
    methods: {
        selected(val) {
            let temp = this.filterItem;
            temp.statusMesinEdc = val;
            this.$store.commit("filterGlobalModule/setFilterItem", temp);
            this.diterapkan = this.filterItem.statusMesinEdc.length > 0;
        },
    },
};
</script>
